export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/member/index.js